export const ROUTES = {
  SESSION_DETAIL: (id: string) => `/sessions/${id}`,
}
